import { tap, ignoreElements } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { gameSelectors, levelSelectors, financialStatementsSelectors } from '~/store';
import levelService from '~/services/level.service';
// ---- local imports ----

import * as actionTypes from '../actionTypes';
// ---- local imports ----


const saveMissionsProgressEpic = (action$, state$) => action$.pipe(
	ofType(
		actionTypes.LEVEL_CREATE_NEW_GAME,
		actionTypes.LEVEL_UPDATE_MISSIONS,
	),
	tap((action) => (save(state$.value, action))),
	ignoreElements()
);

function save(state, action) {
	try {
		const allFS = financialStatementsSelectors.getFinancialStatements(state);
		levelService.saveLevelData(
			gameSelectors.getGameId(state),
			levelSelectors.getLevelNumber(state), 
			levelSelectors.getMissions(state),
			allFS
		);
	} catch (error) {
		console.error(error);
	}
}


export default saveMissionsProgressEpic;
